<template>
	<div class="content">
		<container v-if="!loaded">
			<loading />
		</container>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-medium-size-100 md-size-100">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<h4>{{translate("Overview||ទិន្នន័យស្ថិតិសរុប")}}</h4>
						</div>
						<stat-card data-background-color="orange">
							<template slot="icon">verified</template>
							<template slot="title">{{translate("Total HPC Requests||ចំនួនការស្នើសុំអង្គគណនាពពកកម្រឹតខ្អស់")}}</template>
							<template slot="value">{{overall.total_completed_application}} {{translate("of||នៃ")}}
								{{overall.total_application}}</template>
						</stat-card>
					</div>
				</container>
			</div>
		</div>
	</div>
</template>

<script>

	import { Datetime } from 'vue-datetime';
	import StatCard from '@/components/StatCard'
	export default {
		components: {
			StatCard,
			Datetime
		},
		created() {
			this.getStatistics();
		},
		data() {
			return {
				loaded: false,
				search: {
					loaded: false,
					start_date: "",
					end_date: ""
				},
				overall: {
					total_application: 0,
					total_completed_application: 0,
					total_income: 0,
					total_service: 0,
				},
				overall_service: [],
				range: {
					total_application: 0,
					total_income: 0
				},
				range_service: []
			}
		},
		methods: {
			getStatistics(more = false) {
				this.$http.get(this.config.api + "/user/report/overview").then(data => {
					this.overall = data.body.data.overall;
					this.overall_service = data.body.data.service
					this.loaded = true;
				})
			},
			// getCurrentMonth() {
			// 	var date = new Date();
			// 	var y = date.getFullYear(), m = date.getMonth(), d = date.getDate();

			// 	var start_date = parseInt(((new Date(y, m, 1, 0, 0, 0, 0)).getTime()));
			// 	var end_date = parseInt(((new Date(y, m + 1, 0, 23, 59, 59, 999)).getTime()));

			// 	this.$http.get(this.config.api + "/admin/get/stat/range/" + start_date + "/" + end_date).then(data => {
			// 		this.month = data.body.data;
			// 		this.loaded = true;
			// 	});
			// },
			getRange() {

				this.search.loaded = false;
				let start_date = (new Date(this.search.start_date)).getTime();
				let end_date = (new Date(this.search.end_date)).getTime();

				this.$http.get(this.config.api + "/user/report/range/" + start_date + "/" + end_date).then(data => {
					this.range = data.body.data.range;
					this.range_service = data.body.data.service;
					this.search.loaded = true;
				});
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Dashboard.vue